<template>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 23.5c-.14 0-.28-.05-.39-.16l-3.13-3.13H1.6c-.3 0-.54-.24-.55-.53L.5 1.06C.5.91.55.77.65.66c.1-.11.24-.17.39-.17h21.9c.15 0 .29.06.39.17.1.11.16.25.15.4l-.55 18.62c0 .3-.25.53-.55.53h-6.89l-3.13 3.13c-.11.11-.25.16-.39.16H12z"
        />
    </svg>
</template>
